import { useState, useEffect, useRef } from 'react';

export default function FittingCanvasShaftLean(props) {
    const intl = props.intl;
    const intlHandsForward = intl.formatMessage({ id: "now.hitting.forward" });
    const intlShaftLean = intl.formatMessage({ id: "now.hitting.shaft" });
    const intlHandsNeutral = intl.formatMessage({ id: "now.hitting.hands.neutral" });
    const intlFull = intl.formatMessage({id: 'shot.selection.full'});
    const intlPitch = intl.formatMessage({id: 'shot.selection.pitch'});
    const intlOpenFace = intl.formatMessage({id: 'shot.selection.openface'});

    const [ctx, setCtx] = useState({});
    const canvasRef = useRef(null)
    const shaftLeanStatus = props.shaftleanstatus;

    //keeps canvas drawing ratios clean
    //http://www.petecorey.com/blog/2019/08/19/animating-a-canvas-with-react-hooks/
    const getPixelRatio = context => {
        var backingStore =
            context.backingStorePixelRatio ||
            context.webkitBackingStorePixelRatio ||
            context.mozBackingStorePixelRatio ||
            context.msBackingStorePixelRatio ||
            context.oBackingStorePixelRatio ||
            context.backingStorePixelRatio ||
            1;

        return (window.devicePixelRatio || 1) / backingStore;
    };

    useEffect(() => {
        const canvas = canvasRef.current;
        const context = canvas.getContext('2d');
        setCtx(context);

        let ratio = getPixelRatio(context);
        let width = getComputedStyle(canvas)
            .getPropertyValue('width')
            .slice(0, -2);
        let height = getComputedStyle(canvas)
            .getPropertyValue('height')
            .slice(0, -2);

        canvas.width = width * ratio;
        canvas.height = height * ratio;
        canvas.style.width = `${width}px`;
        canvas.style.height = `${height}px`;

        drawBackground(context, canvas);
    })

    function canvas_arrow(context, fromx, fromy, tox, toy) {
        var headlen = 10; // length of head in pixels
        var dx = tox - fromx;
        var dy = toy - fromy;
        var angle = Math.atan2(dy, dx);
        context.moveTo(fromx, fromy);
        context.lineTo(tox, toy);
        context.lineTo(tox - headlen * Math.cos(angle - Math.PI / 6), toy - headlen * Math.sin(angle - Math.PI / 6));
        context.moveTo(tox, toy);
        context.lineTo(tox - headlen * Math.cos(angle + Math.PI / 6), toy - headlen * Math.sin(angle + Math.PI / 6));
        context.stroke();
    }

    function drawBackground(ctx, canvas) {
        let height = canvas.height;
        let width = canvas.width;
        ctx.clearRect(0, 0, width, height);
        ctx.font = '12px arial';
        ctx.strokeStyle = 'darkgray';
        ctx.fillStyle = 'darkgray';

        //plot the shaft lean axis based on if there is a dynamic loft in the practice shots or not.
        switch (shaftLeanStatus) {
            case "available":
            //shaft lean - left right arrows
            ctx.fillText(intlShaftLean, width * .45, 15);
            ctx.fillText(intlHandsForward, width * .02, 15);
            ctx.fillText(intlHandsNeutral, width * .8, 15);
            canvas_arrow(ctx, width * .61, 11, width * .78, 11)
            canvas_arrow(ctx, width * .43, 11, width * .24, 11)
                break;
            case "unavailable":
                ctx.fillText(intlFull, width * .2, 15);
                ctx.fillText(intlPitch, width * .5, 15);
                ctx.fillText(intlOpenFace, width * .75, 15);
                break;
            case "unknown":
                //no shots yet, so don't plot anything
                break;
        }
    }


        return (
            <>
                <canvas ref={canvasRef} style={{ border: '0px' }} {...props} /><br />
            </>
        )
    }
